import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllCategoriesSlice = createSlice({
  name: "getAllCategories",
  initialState: { data: null, success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      /* TODO: reducer for success*/
      const { data } = action.payload;
      state.data = data;
      state.success = true;
      state.processing = false;
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllCategoriesSlice;
const getAllCategoriesAction = createAction(name);

export {
  getAllCategoriesAction,
  actions as getAllCategoriesActions,
  reducer as getAllCategoriesReducer,
};
